import { PlanModel } from "models";
import { AppLayout } from "layouts";
import { lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Loadable, Page } from "components";
import { setRouting } from "toolkits/redux/routing";
import { Navigate, useRoutes } from "react-router-dom";

const Dashboard = Loadable(
  lazy(() => import("screens/LabAdminRole/Dashboard"))
);
const UserModel = Loadable(lazy(() => import("models/UserModel")));
const LabActionCost = Loadable(
  lazy(() => import("screens/LabAdminRole/LabActionCost"))
);
const OrderView = Loadable(
  lazy(() => import("models/OrderModel/View"))
);
const OrderModel = Loadable(lazy(() => import("models/OrderModel")));
const ActionsModel = Loadable(lazy(() => import("models/ActionsModel")));
const Callback = Loadable(
  lazy(() => import("screens/Authentication/Callback"))
);
const LabStepModel = Loadable(lazy(() => import("models/LabStepModel")));

const OrderCreationNew = Loadable(
  lazy(() => import("screens/UnitAdminRole/OrderCreationNew"))
);

const navConfig = [
  {
    path: "/",
    element: <Navigate to="/app" replace />,
  },
  {
    url: "/",
    path: "/",
    title: "app",
    inSidebar: true,
    element: <AppLayout />,
    children: [
      {
        url: "/app",
        path: "/app",
        title: "app",
        inSidebar: true,
        element: <Dashboard />,
      },
      {
        url: "/callback",
        path: "/callback",
        title: "callback",
        inSidebar: false,
        element: <Callback />,
      },
      // {
      //   url: "/operator",
      //   path: "/operator",
      //   title: "OperatorModel",
      //   inSidebar: true,
      //   element: (
      //     <Page>
      //       <UserModel initFilter={{ mode: "user", type_ids: "3" }} />
      //     </Page>
      //   ),
      // },
      {
        url: "/order",
        path: "/order",
        title: "OrderModel",
        inSidebar: true,
        element: (
          <Page title="Orders">
            <OrderModel />
          </Page>
        ),
      },
      {
        path: "/order/:id",
        title: "OrderView",
        inSidebar: false,
        element: (
          <Page title="OrderView">
            <OrderView />
          </Page>
        ),
      },
      // {
      //   url: "/order-creation-new",
      //   path: "/order-creation-new",
      //   title: "OrderCreation",
      //   inSidebar: true,
      //   element: <OrderCreationNew />,
      // },
      // {
      //   url: "/plan",
      //   path: "/plan",
      //   title: "PlanModel",
      //   inSidebar: true,
      //   element: (
      //     <Page title="PlanModel">
      //       <PlanModel initFilter={{ related_to: "labratoar" }} />
      //     </Page>
      //   ),
      // },
      // {
      //   url: "/lab-step",
      //   path: "/lab-step",
      //   title: "LabStepModel",
      //   inSidebar: true,
      //   element: (
      //     <Page title="LabStepModel">
      //       <LabStepModel />
      //     </Page>
      //   ),
      // },
      {
        url: "/actions",
        path: "/actions",
        title: "ActionsModel",
        inSidebar: true,
        element: (
          <Page title="ActionsModel">
            <ActionsModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
    ],
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "intro",
        element: <Navigate to="/" replace />,
      },
      {
        path: "sign-in",
        element: <Navigate to="/" replace />,
      },
      {
        path: "sign-up",
        element: <Navigate to="/" replace />,
      },
      {
        path: "reset-password",
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/404" replace />,
  },
];

function cleanRoutes({ url, title, inSidebar, children }) {
  if (inSidebar) {
    if (children && children.length > 0) {
      children = children.map((c) => cleanRoutes(c));
      return { url, title, inSidebar, children };
    }
    return { url, title, inSidebar, children: [] };
  }
  return {};
}

export default function Router() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setRouting(navConfig.map((x) => cleanRoutes(x)).filter((x) => x)));
  }, []);
  return useRoutes(navConfig);
}
